import { addMethod, number as yupNumber } from "yup";

import { Translate } from "@/redux/modules/value/translations/translations.provider";

addMethod(yupNumber, "safetyInfoSearch", function () {
    return this.test("safetyInfoSearch", function (value) {
        const length = value?.toString().length || 0;

        const skuRange = length >= 3 && length <= 8;
        const eanRange = length === 13;

        return (
            skuRange ||
            eanRange ||
            this.createError({
                message: () => () => (t: Translate) =>
                    t("form.validation.input.number.safetyInfoSearch")
            })
        );
    });
});
export const safetyInfoSearch = yupNumber()
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .nullable()
    .required()
    .integer()
    .safetyInfoSearch();
